var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUtk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#7C4DFF",
    rx: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m12.673 12 5.569-2.842-.937-1.719-5.1 1.97a.566.566 0 0 1-.407 0l-5.1-1.97-.936 1.719 5.569 2.841-5.57 2.842.937 1.719 5.1-1.97a.567.567 0 0 1 .408 0l5.1 1.97.936-1.72-5.57-2.84Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUtk);
export default __webpack_public_path__ + "static/media/utk.bc8146e3fd6957d13b8a4a51dcfcd94e.svg";
export { ForwardRef as ReactComponent };